module.exports = __webpack_public_path__ + "static/media/spinner.3b5d1e95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/svg/spinner.svg
// module id = 1016
// module chunks = 0